import axios from "axios";
import React, {Component} from "react";
import LoginGoogle from "./LoginGoogle";
import ReactLoading from "react-loading";
import "./Login.css";

class Login extends Component{

    state = {
        username : "",
        password : "",
        error : "",
        click : false,
        checked : true,
    }
    componentDidMount(){
        window.localStorage.clear();
    }
    
    handleInput = (e) => {
        this.setState({
            [e.target.name]: e.target.value,
            click : false
        });
    }

    getLogin  = () => {

        this.setState({
            click : true,
            error : ""
        })
         axios.post("login", {
            username: this.state.username,
            password: this.state.password
        }).then((login) => {
            localStorage.setItem("user", JSON.stringify(login.data.data));
            localStorage.setItem("branche", JSON.stringify(login.data.branche ? login.data.branche : {}) );
            localStorage.setItem("permissions", JSON.stringify(login.data.permissions ? login.data.permissions : []) );
            window.location.replace(process.env.REACT_APP_EVIVEMANIFESTE);
        }).catch((error) => {
            window.localStorage.clear();
            this.setState({
                click : false,
                error: error?.response?.data.msg,
            });
        });
        
    }
    
    render(){
        return(
            <div className="login-page">
                <div className="login-page__glow login-page__glow--gold"></div>
                <div className="login-page__glow login-page__glow--green"></div>

                <div className="login-shell">
                    <section className="login-brand">
                        <div className="login-brand__logo">
                            <img src="/img/logo2.png" alt="La victoire express" />
                        </div>
                        <p className="login-brand__kicker">Espace securise</p>
                        <h1>Gerez les manifestes avec clarte.</h1>
                        <p className="login-brand__text">
                            Accedez rapidement aux expeditions, factures et rapports depuis un tableau de bord concu pour vous.
                        </p>
                        <div className="login-brand__features">
                            <span><i className="fa fa-check-circle"></i> Suivi centralise</span>
                            <span><i className="fa fa-shield"></i> Donnees protegees</span>
                            <span><i className="fa fa-dashboard"></i> Travail plus rapide</span>
                        </div>
                    </section>

                    <section className="login-card" aria-label="Formulaire de connexion">
                        <div className="login-card__header">
                            <span className="login-card__icon"><i className="fa fa-lock"></i></span>
                            <div>
                                <p>Bienvenue</p>
                                <h2>Connexion</h2>
                            </div>
                        </div>

                        <form className="login-form">
                            {this.state.error && (
                                <div className="login-alert">
                                    <i className="fa fa-exclamation-circle"></i>
                                    <span>{this.state.error}</span>
                                </div>
                            )}

                            <div className="login-field">
                                <label htmlFor="username">Téléphone ou mail</label>
                                <div className="login-input">
                                    <i className="fa fa-user"></i>
                                    <input
                                        type="text"
                                        id="username"
                                        name="username"
                                        onChange={this.handleInput}
                                        placeholder="exemple@email.com"
                                    />
                                </div>
                            </div>

                            <div className="login-field">
                                <label htmlFor="userpassword">Mot de passe</label>
                                <div className="login-input">
                                    <i className="fa fa-key"></i>
                                    <input
                                        type="password"
                                        name="password"
                                        onChange={this.handleInput}
                                        id="userpassword"
                                        placeholder="Votre mot de passe"
                                    />
                                </div>
                            </div>

                            <button className="login-button" type="button" onClick={() => this.getLogin()} disabled={this.state.click}>
                                <span>Connexion</span>
                                {!this.state.click ? (
                                    <i className="fa fa-long-arrow-right"></i>
                                ) : (
                                    <ReactLoading type="spokes" height={18} width={18} />
                                )}
                            </button>

                            <div className="login-google d-none">
                                <LoginGoogle />
                            </div>
                        </form>
                    </section>
                </div>
            </div>
        )
    }
}
export default Login
